import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles({
  loadingPlaceholder: {
    height: 4,
    position: "absolute",
    width: "100%",
    zIndex: 10,
  },
});
